import { UpdateFoodStockMinimumQuantityDTO } from '../models/FoodStock'
import { FoodStockRepository } from '../repositories/FoodStockRepository'

export function UpdateFoodStockMinimumQuantityCase(
  foodStockRepository: FoodStockRepository
) {
  return async function (
    stockFoodId: string,
    data: UpdateFoodStockMinimumQuantityDTO
  ) {
    return await foodStockRepository.updateFoodStockMinimumQuantity(
      stockFoodId,
      data
    )
  }
}
